import React from "react";
import { Col, Row } from "react-bootstrap";
import "./orderProductCard.css";

function OrderProductCard({ product }) {
  const price = +product.price;

  return (
    <Row className="orderProduct">
      <Col md={3}>
        <img src={product && product.imageUrl} className="orderProduct__img" />
      </Col>
      <Col md={9}>
        <div className="orderProduct__Details">
          <h6>{`${product.quantity} - ${product.productName}`}</h6>
        </div>

        <div className="orderProduct__Details">
          {/* <h6>Ksh {product.productPrice.toLocaleString()}</h6> */}
          <h6>Price: Kshs {+price * +product.quantity}</h6>
        </div>
      </Col>
    </Row>
  );
}

export default OrderProductCard;
